import { render, staticRenderFns } from "./PatientFile.vue?vue&type=template&id=2f31b695&scoped=true&"
import script from "./PatientFile.vue?vue&type=script&lang=js&"
export * from "./PatientFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31b695",
  null
  
)

export default component.exports